/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPromoCode_item = {
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_item">;
    readonly " $refType": "PdpSharedPromoCode_item";
};
export type PdpSharedPromoCode_item$data = PdpSharedPromoCode_item;
export type PdpSharedPromoCode_item$key = {
    readonly " $data"?: PdpSharedPromoCode_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedPromoCode_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ea46f36575e44c5e9545ccb796db55f6';
export default node;
